import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const useTrackingNumbers = cartId => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: [`tracking-numbers`, cartId],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/tracking-numbers/by-cart-id/${cartId}`);
      return response.data;
    },
    throwOnError: errorMessage,
    enabled: !!cartId,
  });
  return query;
};
